<template>
  <div class="button-wrapper">
    <div
      class="button"
      :style="`
        background: ${background};
        color: ${color};
        font-weight: ${bold ? 'bold' : 'normal' }
      `"
      @click="() => action()"
    >
      <span v-if="icon">
        <asset-v3 dir="icons" :name="`${icon}.svg`"/>
      </span>
      {{ text }}
    </div>
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
    },
    background: {
      type: String,
      default: '#36A3CA',
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
    bold: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
  },
  components: {
    AssetV3,
  },
};
</script>

<style scoped>
.button-wrapper {
  cursor: pointer;
  margin-top: 16px;
  grid-column-start: 2;
}
.button {
  border-radius: 4px;
  padding: 7px 0px;
  text-align: center;
  width: fit-content;
  padding: 10px 16px;
  margin-left: auto;
  display: flex;
  align-items: center;
}
</style>
<style>
.button-wrapper span {
  height: 14px;
  display: flex;
  align-items: center;
  margin-right: 5px;
}
</style>
